module.exports = __webpack_public_path__ + "img/e-wallet@2x.ef8eec60.png";